
import angular from 'angular';
import { BehaviorSubject, from } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

import { AudienceTypeEnum } from 'src/app/marketing/audience/shared/audience-type.enum';

AudienceController.$inject = [
  '$scope',
  'AlertingFactory',
  'TopToolbarFactory',
  '$translate',
  '$state',
  'AudienceFactory',
  'company',
  '$mdDialog',
  'MassMessagingFactory',
  'sites',
  'SiteFilterHelperFactory',
  'SegmentsFactory',
  '$stateParams',
  'MetricsFactory',
  'AngularOptinsService',
  'MediasFactory',
  'AngularSpinnerService'
];
export function AudienceController(
  $scope,
  AlertingFactory,
  TopToolbarFactory,
  $translate,
  $state,
  AudienceFactory,
  company,
  $mdDialog,
  MassMessagingFactory,
  sites,
  SiteFilterHelperFactory,
  SegmentsFactory,
  $stateParams,
  MetricsFactory,
  AngularOptinsService,
  MediasFactory,
  AngularSpinnerService
) {

  $scope.exportXls = exportXls;
  $scope.fetchUsers = fetchUsers;
  $scope.maybeUpdateQuery = maybeUpdateQuery;
  $scope.updateFiltersStatus = updateFiltersStatus;
  $scope.importUserOptin = importUserOptin;

  $scope.lastUserOptinIdRetrieved = null;
  $scope.lastUserOptoutIdRetrieved = null;
  $scope.BUFFER_SIZE = 20;
  $scope.usersBS = new BehaviorSubject({
    usersOptinList: [],
    usersOptoutList: []
  });

  $scope.statisticsBS = new BehaviorSubject({
    optins: { retrieved: 0, total: 0 },
    optouts: { retrieved: 0, total: 0 },
  });

  init();

  function _resetUsersList() {
    $scope.usersBS.next({
      usersOptinList: [],
      usersOptoutList: []
    });
    $scope.statisticsBS.next({
      optins: { retrieved: 0, total: 0 },
      optouts: { retrieved: 0, total: 0 },
    });
  }

  function submitQuery() {
    AngularSpinnerService.showSpinner();
    // Format from and to dates in filters
    const formattedFilters = AudienceFactory.formattedAudienceFilters($scope.filters);
    _resetUsersList();
    from(AudienceFactory.getUserExternalIds(company.id, { filters: formattedFilters }))// Fetch the user ids matching the filters
      .pipe(finalize(() => AngularSpinnerService.hideSpinner()))
      .subscribe({
        next: response => {
          const { userOptinIdList = [], userOptoutIdList = [] } = response.data;
          $scope.userOptinIdList = userOptinIdList;
          $scope.userOptoutIdList = userOptoutIdList;
          $scope.lastUserOptinIdRetrieved = $scope.userOptinIdList[0];
          $scope.lastUserOptoutIdRetrieved = $scope.userOptoutIdList[0];
          _fetchUserOptouts();
          _fetchUserOptins();

          _refreshStatistics();
        },
        error: AlertingFactory.httpErrorHandler()
      });
  }

  function exportXls() {
    /*
     * TODO There is an issue with the custom fields for Air France. consider to re activate once BE is ready.
     */
    $mdDialog
      .show({
        controller: [
          '$scope',
          ($scope) => {
            $scope.data = {
              componentName: 'SelectAudienceCustomFieldsToExportComponent',
            }
            $scope.cancelDialog = $mdDialog.cancel;
            $scope.hideDialog = $mdDialog.hide;
          }
        ],
        template: `<angular-dialog-container-for-ajs
                    [data]="data"
                    (hide-dialog)="hideDialog($event)"
                    (cancel-dialog)="cancelDialog()"
                  ></angular-dialog-container-for-ajs>`,
      })
      .then((customFields) => {
        const { userOptinIdList, userOptoutIdList } = $scope;
        AngularSpinnerService.showSpinner();
        from(AudienceFactory.createExport(company.id, { userOptinIdList, userOptoutIdList, customFields }))
          .pipe(finalize(() => AngularSpinnerService.hideSpinner()))
          .subscribe({
            next: response => {
              if (response.data) {
                const { content, content_type, content_filename } = response.data;
                MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
              }
            },
            error: AlertingFactory.httpErrorHandler()
          });
      });
  }

  function fetchUsers({ scrollEvent, selectedTabIndex }) {
    const scrollableElement = scrollEvent.target;
    if (scrollableElement.scrollHeight - scrollableElement.scrollTop <= scrollableElement.clientHeight) {
      if (selectedTabIndex === AudienceTypeEnum.OPTOUT) {
        if ($scope.lastUserOptoutIdRetrieved === null || $scope.lastUserOptoutIdRetrieved > 0) {
          _fetchUserOptouts();
        }
      } else if ($scope.lastUserOptinIdRetrieved === null || $scope.lastUserOptinIdRetrieved > 0) {
        _fetchUserOptins();
      }
    }
  }


  function _fetchUserOptins() {
    AngularSpinnerService.showSpinner();
    const index = $scope.userOptinIdList.indexOf($scope.lastUserOptinIdRetrieved);
    const userOptMaxIndexToRetrieve = +index + +$scope.BUFFER_SIZE
    const userOptinIdList = $scope.userOptinIdList.slice(index, userOptMaxIndexToRetrieve);
    from(AudienceFactory.getUsers(company.id, { userOptinIdList }))
      .pipe(finalize(() => AngularSpinnerService.hideSpinner()))
      .subscribe({
        next: response => {
          const users = response.data.users.map(user => ({
            ...user,
            isActiveForPeriodLabel: $translate.instant(user.is_active_for_period ? 'yes' : 'no'),
            isVipLabel: $translate.instant(user.is_vip ? 'yes' : 'no'),
          }))
          $scope.usersBS.next({
            usersOptinList: ($scope.usersBS.value.usersOptinList || []).concat(users),
            usersOptoutList: ($scope.usersBS.value.usersOptoutList || [])
          });

          _refreshStatistics();

          $scope.lastUserOptinIdRetrieved = $scope.userOptinIdList[userOptMaxIndexToRetrieve];
        },
        error: AlertingFactory.httpErrorHandler()
      });
  }

  function _fetchUserOptouts() {
    AngularSpinnerService.showSpinner();
    const index = $scope.userOptoutIdList.indexOf($scope.lastUserOptoutIdRetrieved);
    const userOptMaxIndexToRetrieve = +index + +$scope.BUFFER_SIZE
    const userOptoutIdList = $scope.userOptoutIdList.slice(index, userOptMaxIndexToRetrieve);
    from(AudienceFactory.getUsers(company.id, { userOptoutIdList }))
      .pipe(finalize(() => AngularSpinnerService.hideSpinner()))
      .subscribe({
        next: response => {
          const users = response.data.users.map(user => ({
            ...user,
            isVipLabel: $translate.instant(user.is_vip ? 'yes' : 'no'),
          }))
          $scope.usersBS.next({
            usersOptinList: ($scope.usersBS.value.usersOptinList || []),
            usersOptoutList: ($scope.usersBS.value.usersOptoutList || []).concat(users)
          });

          _refreshStatistics();

          $scope.lastUserOptoutIdRetrieved = $scope.userOptoutIdList[userOptMaxIndexToRetrieve];
        },
        error: AlertingFactory.httpErrorHandler()
      });
  }

  function _refreshStatistics() {
    $scope.statisticsBS.next({
      optins: { retrieved: ($scope.usersBS.value.usersOptinList || []).length, total: ($scope.userOptinIdList || []).length },
      optouts: { retrieved: ($scope.usersBS.value.usersOptoutList || []).length, total: ($scope.userOptoutIdList || []).length },
    });
  }

  function maybeUpdateQuery() {
    if (!angular.equals($scope.previousFilters, $scope.filters)) {
      updateFiltersStatus();

      if ($scope.hasFilters) {
        submitQuery();
      }
      $scope.previousFilters = angular.copy($scope.filters);
    }
  }

  function updateFiltersStatus() {
    $scope.hasFilters = Object.values($scope.filters).every(f => angular.isArray(f) ? f.length > 0 : f != null);
  }

  // Only allow creating a mass messaging entry if exactly one account is selected, as the mass messaging will consist of sending a scenario
  function updateIsMassMessagingButtonDisabled() {
    if ($scope.filters) {
      const { accounts, segment } = $scope.filters;
      const enabled = accounts?.length === 1 && segment;
      TopToolbarFactory.updateSecondaryButtonDisable(!enabled, $scope);
    }
  }

  function addMassMessaging(event) {
    const sitesWithSortKey = angular.copy(sites);
    SiteFilterHelperFactory.addSortKeysAndSort(sitesWithSortKey);
    const newMassMessaging = {
      name: $translate.instant('mass_messaging/new_mass_messaging'),
      audience_filters: AudienceFactory.formattedAudienceFilters($scope.filters),
      entrypoint_scenario_unique_id: null
    };
    const audienceSites = $scope.filters.accounts;
    const dropdownItems = $scope.dropdownItems;
    AngularSpinnerService.showSpinner();
    from(MetricsFactory.getScenarios($stateParams.companyId, 'campaign-scenarios'))
      .pipe(
        map(result => result.data),
        finalize(() => AngularSpinnerService.hideSpinner())
      )
      .subscribe({
        next: campaignScenarios => {
          const entrypointsDropdownItems = MassMessagingFactory.buildMassMessagingEntrypointsDropdownItems(campaignScenarios, audienceSites);
          MassMessagingFactory._addUIFields(newMassMessaging, sitesWithSortKey);
          const audienceSize = $scope.statisticsBS.value?.optins?.total || 0;
          $mdDialog
            .show({
              controller: [
                '$scope',
                ($scope) => {
                  $scope.data = {
                    componentName: 'CreationEditionDialogComponent',
                    audienceSize,
                    audienceDropdownItems: dropdownItems,
                    isNewMassMessaging: true,
                    massMessaging: newMassMessaging,
                    massMessagingEntrypointsDropdownItems: entrypointsDropdownItems,
                  }
                  $scope.cancelDialog = $mdDialog.cancel;
                  $scope.hideDialog = $mdDialog.hide;
                }
              ],
              template: `<angular-dialog-container-for-ajs
          [data]="data"
          (hide-dialog)="hideDialog($event)"
          (cancel-dialog)="cancelDialog()"
          ></angular-dialog-container-for-ajs>`,
              targetEvent: event
            })
            .then((massMessaging) => {
              let status = 0;
              const { scheduledTime } = massMessaging;
              if (scheduledTime) {
                status = 1;
              }
              MassMessagingFactory.createMassMessaging(company.id, massMessaging).then(
                () => $state.go('auth.alcmeon.fuse.mass-messaging', { status }),
                AlertingFactory.httpErrorHandler()
              );
            });
        }
      })
  }

  function init() {
    TopToolbarFactory.setButton('task_list/export', exportXls, $scope);

    TopToolbarFactory.setSecondaryButton('mass_messaging/new_mass_messaging', addMassMessaging, $scope);

    const companySuffix = `-${company.id}`;
    $scope.dateRangeKey = 'audience-field-dateRange' + companySuffix;
    $scope.dateRangeLabel = $translate.instant('audience/optin_date_range');
    $scope.optinsExpirationDateRangeKey = 'audience-field-expirationDateRange' + companySuffix;
    $scope.optinsExpirationDateRangeLabel = $translate.instant('audience/expiration_optin_date_range');
    $scope.accountKey = 'audience-field-account' + companySuffix;
    $scope.accountLabel = $translate.instant('audience/account_name');
    $scope.segmentKey = 'audience-field-segment' + companySuffix;
    $scope.segmentLabel = $translate.instant('segment');

    $scope.filters = {
      dateRange: {
        from: null,
        to: null,
      },
      expireDateRange: {
        from: null,
        to: null,
      },
      accounts: null,
      segment: null
    };

    from(SegmentsFactory.getSegments($stateParams.companyId)).pipe(map(result => result.data.segments))
      .subscribe((segments) => {
        $scope.dropdownItems = AudienceFactory.buildDropdownItems(sites, segments);
      });

    $scope.userOptinIdList = [];
    $scope.userOptoutIdList = [];

    $scope.$watch('hasFilters', () => maybeUpdateQuery());
    $scope.$watch('filters', () => updateIsMassMessagingButtonDisabled(), true);
  }

  function importUserOptin(event) {
    AngularOptinsService.getOptins()
      .subscribe({
        next: res => {
          const optins = res.filter(o => o.type === AngularOptinsService.OPTIN_TYPE_DEFAULT);
          $mdDialog.show({
            controller: 'UserOptinImportController',
            template: require('./user-optin-import.dialog.html'),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
              company: company,
              sites: sites.filter(s => s.type === 12), //Only whatapp sites (12),
              optins
            }
          });
        }
      })
  }
}
